import React from "react";

export default function Page2() {
  return (
    <div className="flex flex-col gap-5 sm:gap-10 p-5 sm:p-10 py-10 sm:py-20">
      <span className="text-[20px] sm:text-[40px]">ALPHA ROBOTICS LLP</span>
      <div className="h-[0.5px] w-full bg-slate-200"></div>
      <span className="font-extralight text-[12px] sm:text-[14px]">
        We present advanced trading solutions designed to streamline your
        investment experience. Our most prominent feature is the Alpha Trading
        Bot, which is capable of increasing user profits through automated
        trading. The bot continuously scans the market for trends, optimizes
        trading positions, and manages trades on the user's behalf using
        sophisticated algorithms and enhanced technology.
      </span>
    </div>
  );
}
